import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/trash.svg';

export const IconTrash: IconComponent = props => <Icon {...props} src={src} />;
